// List view on a Notes List-linked show (Josh, 9 Oct 2026, mock v2): the Work Note column becomes a Notes List column.
// Every row has the Add Note button and the open count; a Cuelist work note still live on the cue shows read-only beside
// them until archived, and once none are left the column narrows to the button and count.

// Button (21) + gap + the "*12" count, plus cell padding. Also fits the "Notes List" header.
export const NARROW_WIDTH = 72;
// Button + count, the "Cuelist work note" tag, the archive button, gaps and padding, around the note text itself.
const LEFTOVER_CHROME = 215;
const MAX_WIDTH = 400;

// The live note's text, or null. Both stored shapes: the legacy string, and the array where archived notes stay behind.
// A ticked note with no text yet (' ') is live, as it is for the cue asterisk.
export function liveWorkNoteText(workNote) {
    if (typeof workNote === 'string') return workNote === '' ? null : workNote;
    if (!Array.isArray(workNote)) return null;
    for (let i = 0; i < workNote.length; i += 1) {
        const n = workNote[i];
        if (n && !n.archived) return n.note == null ? '' : n.note;
    }
    return null;
}

// One pass over the list, stopping at the first live note: decides the column width, so it runs once, not per row.
export function anyLiveWorkNote(cues) {
    for (let i = 0; i < cues.length; i += 1) {
        const cue = cues[i];
        if (cue && cue.data && liveWorkNoteText(cue.data.workNote) !== null) return true;
    }
    return false;
}

export function notesListColumnWidth(widestNoteTextPx, anyLive) {
    if (!anyLive) return NARROW_WIDTH;
    return Math.max(NARROW_WIDTH, Math.min(MAX_WIDTH, Math.ceil(widestNoteTextPx) + LEFTOVER_CHROME));
}


// WEBPACK FOOTER //
// ./src/lib/noteslist-column.js